<template>
    <pg-page title="Personal training bij Private Gym"
             header="Personal training bij Private Gym"
             id="voor-pts"
    >

        <div class="mx-auto mt-4">
            <div class="row">
                <div class="col-12">
                    <header-and-text-block header-placement="left">
                        <template v-slot:header>
                            Persoonlijke begeleiding
                        </template>
                        Bij Private Gym kun je zo veel of weinig als je wil trainen met een personal trainer. En hiermee
                        combineren we het beste van twee werelden: de privacy en comfort van een personal trainer, met de
                        toegankelijkheid van een reguliere gym.
                    </header-and-text-block>
                </div>
                <div class="col-12">
                    <header-and-text-block header-placement="right">
                        <template v-slot:header>
                            Voor ieder budget
                        </template>
                        Bij Private Gym kun je er voor kiezen om een X aantal dagen per week met personal trainer te trainen, maar ook 1x per 4 weken, of op aanvraag. Zo kun je zelf naar behoefte en budget kiezen. <br/><br/>Het grote voordeel is dat je naast de personal training ook nog 24/7 onbeperkt met je Private Gym abonnement kunt sporten. Met dezelfde apparatuur. Op hetzelfde eiland als waar je personal training krijgt.
                    </header-and-text-block>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-4 my-4">
                    <div class="card bg-dark text-white">
                        <img src="/images/personal-training/1.jpeg" class="card-img"
                             alt="Private Gym personal training">
                        <div class="card-img-overlay">
                            <!--                            <h5 class="card-title">Card title</h5>-->
                            <!--                            <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>-->
                            <!--                            <p class="card-text">Last updated 3 mins ago</p>-->
                        </div>
                    </div>
                </div>
                <div class="col-sm-4 my-4">
                    <div class="card bg-dark text-white">
                        <img src="/images/personal-training/2.jpeg" class="card-img"
                             alt="Private Gym personal training">
                        <div class="card-img-overlay">
                            <!--                            <h5 class="card-title">Card title</h5>-->
                            <!--                            <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>-->
                            <!--                            <p class="card-text">Last updated 3 mins ago</p>-->
                        </div>
                    </div>
                </div>
                <div class="col-sm-4 my-4">
                    <div class="card bg-dark text-white">
                        <img src="/images/personal-training/3.jpeg" class="card-img"
                             alt="Private Gym personal training">
                        <div class="card-img-overlay">
                            <!--                            <h5 class="card-title">Card title</h5>-->
                            <!--                            <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>-->
                            <!--                            <p class="card-text">Last updated 3 mins ago</p>-->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <header-and-text-block header-placement="left">
                        <template v-slot:header>
                            Werken aan je doelen?
                        </template>
                        We hebben een team aan personal trainers die klaar staan voor jou, ieder met hun eigen
                        specialiteiten. De één focust op kracht, de ander op conditie of trainen met blessures en/of voeding. Maar één
                        ding is zeker: allemaal zullen ze jou helpen motivatie en plezier te vinden in sporten. En je doelen te bereiken.
                    </header-and-text-block>
                </div>
                <div class="col-12">
                    <header-and-text-block header-placement="right">
                        <template v-slot:header>
                            Rust en ruimte
                        </template>
                        Begeleiding, coaching en trainen met de hoeveelheid persoonlijke aandacht die jij wil. En
                        daarnaast trainen <em>wanneer</em> jij wil. Altijd op je eigen eiland. In rust en privacy.
                        Beginnen met 2x in de week en dan afbouwen naar 1x per 4 weken terwijl jij groeit in vertrouwen.
                        3x per week. 1x per 2 maanden. Het kan allemaal. Da's de kracht van personal training bij Private Gym.
                    </header-and-text-block>
                </div>
            </div>
        </div>

        <div class="col my-3 py-3 text-center">
            <h3 class="">
                <strong>
                    Meer informatie? Plan een rondleiding of stel je vraag via Whatsapp!
                </strong>
            </h3>
        </div>

        <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mb-0  border-bottom border-top py-4">
            <rondleiding-button :w100="false" class="me-sm-3 col-sm-6"
                                calendly-url="https://calendly.com/private-gym/private-gym-rondleiding-door-personal-trainer"></rondleiding-button>

            <a type="button" class="btn btn-success btn-lg m-2 mb-3 px-4 col-sm-6"
               href="https://wa.me/+31649672871?text=Ik%20zou%20graag%20wat%20meer%20informatie%20willen%20over%20personal%20training%20bij%20Private%20Gym"
               rel="_blank">
                <i class="bi bi-whatsapp" style="margin-right: 12px;"></i><span
                style="display: inline-block;">WhatsApp</span>
            </a>
            <!--            <a type="button" class="btn btn-dark btn-lg px-4 me-sm-3 col-sm-6" @click.prevent="showFormModal = true">-->
            <!--                <i class="bi bi-chevron-right" style="margin-right: 12px;"></i>-->
            <!--                Contact mij-->
            <!--            </a>-->
        </div>


        <contact-modal
            v-if="showFormModal"
            @closed="showFormModal = false"
            type="pts"
        ></contact-modal>

    </pg-page>
</template>

<script>

import PgPage from "../Components/PgPage";
import ContactModal from "../Components/Contact/ContactModal";
import RondleidingButton from "../Components/Index/RondleidingButton";
import HeaderAndTextBlock from "../Components/Layout/HeaderAndTextBlock";

export default {
    components: {HeaderAndTextBlock, RondleidingButton, ContactModal, PgPage},

    props: [],

    mixins: [],

    data: function () {
        return {
            showFormModal: false,
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
